import { searchCommonConfig } from './common'

/**
 * AureNovel 品牌搜索页面配置
 */
export const searchConfig = {
  ...searchCommonConfig,
  colors: {
    inputBg: '#0000000A',
    startReadingBg: 'linear-gradient(90deg, #FFD666 0%, #FFB300 100%)',
  },
}
